import GridVoucherFormPage from "./GridVoucherFormPage";

/**
 * Credit Note - reduces a member's or vendor's outstanding balance without a
 * bank/cash movement. Accounting mapping depends on context (e.g. Dr Vendor
 * Payable / Cr Repairs & Maintenance to reverse part of an over-billed
 * vendor bill, or Dr Maintenance Income / Cr Member Receivable to waive a
 * charge) so this uses the same multi-line grid as Journal rather than a
 * fixed two-account shape, with an Original Reference field for the bill or
 * voucher being adjusted.
 */
export default function CreditNotePage() {
  return (
    <GridVoucherFormPage
      voucherType="CREDIT_NOTE"
      title="Credit Note"
      subtitle="Reduce a member's or vendor's outstanding balance without a bank/cash movement. Reference the original bill and state the reason in the narration."
      referenceLabel="Original Reference"
      showVendorHelper
      emptyStateNote="No credit notes yet. Create your first credit note above."
    />
  );
}
